import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"display":"flex"}
}
const _hoisted_2 = ["data-index"]
const _hoisted_3 = {
  key: 0,
  class: "r_nav"
}
const _hoisted_4 = ["onClick"]

import menuTree from './menuTree1.vue';
import { nextTick, onMounted, reactive, ref, toRaw } from 'vue';
type Menu = {
    Name: string,
    Children?: Menu[],
    ParentId: number,
    Id: number,
    riIndex:number
}
type Props = {
    menuList: Menu[],
    index: number,
    width:number,
    Id:number,
    riIndex: number
    PageType: number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'menuTree1',
  props: {
    menuList: {},
    index: {},
    width: {},
    Id: {},
    riIndex: {},
    PageType: {}
  },
  emits: ['MenuTree1'],
  setup(__props: any, { emit: __emit }) {

let person: any = reactive({
    IsChild: [],
    ClickId: 0,
    Pid: 0,
    index: 0,
    width: 0,
    menuActive:-1,
    cwidth:0,
    cache:''
})
const isChild = ref()
var prop = __props
let prs = toRaw(prop)
const emits = __emit;

const goPage = (data: Menu[], Id: number, Pid: number, index: number) => {
    person.menuActive = Id
    person.isChild = data
    person.ClickId = Id
    person.Pid = Pid
    person.index = person.index + 1
    var a = document.getElementsByClassName('r_item_title')
    for (let index = 0; index < a.length; index++) {
        const element = a[index];
        var di = element.getAttribute('data-index')
        if (Number(di) === Pid) {
            // person.width = element.scrollWidth // + 15
            // 获取元素
            let secMargin = getComputedStyle(element);
            person.width = element.scrollWidth + parseFloat(secMargin.marginRight.replace('px', ''))
            break;
        }
    }
    emits('MenuTree1', Pid, Id, data, prop.riIndex, index);
};
const inIntClick = () => {
    //取缓存
    if (prop.PageType === 1 || prop.PageType === 2 || prop.PageType === 3) {
        person.cache = localStorage.getItem('clickRecord')
    } else if (prop.PageType === 4) {
        person.cache = localStorage.getItem('clickQuestion')
    }
    if (person.cache !== '' && person.cache!==null) {
        var arr = JSON.parse(person.cache)
        prop.menuList[0].Children && prop.menuList[0].Children.forEach((x: any) => {
            var a = arr.filter((s: any) => s.key === x.Id)[0]
            if (a !== null && a !== undefined) {
                goPage(a.value, a.key, a.Pid, 0)
            }
        })
    }
}

const MenuTree1 = (Pid: number, Id: number, item: any, riIndex: number, index:number) => {
    emits('MenuTree1', Pid, Id, item, riIndex, index);
}
onMounted(()=>{
    inIntClick()
    nextTick(()=>{
        person.cwidth = document.body.scrollWidth
        window.onresize=()=>{
            var a = document.getElementsByClassName('r_item_title')[0]
            let secMargin = getComputedStyle(a);
            var w = a.scrollWidth + parseFloat(secMargin.marginRight.replace('px', ''))
            //获取所有的r_item 元素
            var r_item = document.getElementsByClassName('r_item')
            for (let index = 0; index < r_item.length; index++) {
                const element = r_item[index];
                //判断是否存在margin-left
                let elementSecMargin = getComputedStyle(element);

                var i = elementSecMargin.marginLeft.replace('px', '')
                if (parseInt(i)<0){
                    element.style.marginLeft = -w + "px"
                }
            }
        }
    })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuList, (right, riIndex) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "r_item",
      style: _normalizeStyle('width:100%;margin-left:' + (_unref(prs).index > 0 ? -_unref(prs).width : 0) + 'px'),
      key: riIndex
    }, [
      (right.Children &&right.Children.length>0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "r_item_title",
              "data-index": right.Id
            }, _toDisplayString(right.Name) + ">", 9, _hoisted_2),
            (right.Children && right.Children.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(right.Children, (chi, chiIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["r_nav_item", `${_unref(person).menuActive == chi.Id ? 'r_nav_item_active' : ''} ${right.Children.length === 1 ?'r_nav2':''}`]),
                      key: chiIndex,
                      onClick: ($event: any) => (goPage(chi.Children, chi.Id, right.Id, chiIndex+1))
                    }, _toDisplayString(chi.Name), 11, _hoisted_4))
                  }), 128)),
                  (_unref(person).isChild && _unref(person).isChild[0]?.ParentId == _unref(person).ClickId && right.Id == _unref(person).Pid)
                    ? (_openBlock(), _createBlock(menuTree, {
                        key: 0,
                        menuList: _unref(person).isChild,
                        width: _unref(person).width,
                        Id: _unref(person).ClickId,
                        index: 1,
                        riIndex: _unref(prop).riIndex+1,
                        PageType: _unref(prop).PageType,
                        onMenuTree1: MenuTree1
                      }, null, 8, ["menuList", "width", "Id", "riIndex", "PageType"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 4))
  }), 128))
}
}

})